import Transformer from './transformer';

export default class AggregatedSalesReportTransformer extends Transformer {
  static fetch(row) {
    return {
      productId: row.product_id || null,
      productName: row.product_name || null,
      productNumber: row.product_number || null,
      clientId: row.client_id || null,
      clientName: row.client_name || null,
      clientNumber: row.client_number || null,
      clientTypeId: row.client_type_id || null,
      clientTypeName: row.client_type_name || null,
      period: row.period || null,
      totalVolumeLiters: parseFloat(row.total_volume_liters) || 0,
      totalRevenueNet: parseFloat(row.total_revenue_net) || 0,
      totalRevenueGross: parseFloat(row.total_revenue_gross) || 0,
      orderCount: parseInt(row.order_count, 10) || 0,
      totalQuantityUnits: parseFloat(row.total_quantity_units) || 0,
    };
  }

  static send() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/aggregatedSalesReport.js